export const clientKey = ''; 
export const variantKey = 'amazingpay_masan'; 
